import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-localize-redux';
import Icon, { IconSizes, IconVariants } from '../../../components/foundations/Icon';
import { Button } from '../../../components/widgets';
import Badge, { BadgeVariants } from '../../../components/atoms/Badge';
import { translationPrefix } from '../../utils';
import CollapsibleItemGrid from './CollapsibleItemGrid';
import StepCard from '../StepCard';
import css from './SanSourcesReviewCard.css';

const SanSourcesReviewCard = ({ pageId, items, agencyId, onEditStep }) => (
    <StepCard
        title={`${translationPrefix}.REVIEW.SAN_SOURCES_TITLE`}
        titleTextReplace={{ count: items.length }}
        titleAdornment={
            <Badge variant={BadgeVariants.WARNING} color="var(--warning1Color)" className={css.viewOnlyBadge}>
                <Icon name="eye" size={IconSizes.X_SMALL} variant={IconVariants.WARNING} interactive={false} />
                <Translate id={`${translationPrefix}.MANAGE_PERMISSIONS_PAGE.VIEW_ONLY`} />
            </Badge>
        }
        headerChildren={
            <Button
                type="secondary"
                Icon="pencil-line"
                iconLocation="left"
                iconSize={IconSizes.X_SMALL}
                onClick={() => onEditStep(pageId)}
            >
                <Translate id="STATIC.BUTTONS.EDIT" />
            </Button>
        }
        className={css.sanCard}
        contentClassName={css.sanContent}
        titleRowClassName={css.titleRow}
        collapsible
    >
        <CollapsibleItemGrid items={items} />
        <div className={css.namingInfo}>
            <div className={css.namingInfoHeader}>
                <Icon name="info-circle" size={IconSizes.SMALL} variant={IconVariants.WARNING} interactive={false} />
                <Translate id={`${translationPrefix}.REVIEW.SAN_CAMPAIGN_NAMING_TITLE`} />
            </div>
            <Translate
                id={`${translationPrefix}.REVIEW.SAN_CAMPAIGN_NAMING_BODY`}
                data={{ agencyId }}
                options={{ renderInnerHtml: true }}
            />
            <Translate id={`${translationPrefix}.REVIEW.SAN_CAMPAIGN_NAMING_NOTE`} />
            <div className={css.exampleBox}>
                <div className={css.exampleLabel}>
                    <Translate id={`${translationPrefix}.REVIEW.SAN_CAMPAIGN_EXAMPLE_LABEL`} />
                </div>
                <code className={css.exampleValue}>
                    <Translate id={`${translationPrefix}.REVIEW.SAN_CAMPAIGN_EXAMPLE_VALUE`} data={{ agencyId }} />
                </code>
            </div>
        </div>
    </StepCard>
);

SanSourcesReviewCard.propTypes = {
    pageId: PropTypes.string.isRequired,
    agencyId: PropTypes.string.isRequired,
    onEditStep: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            displayName: PropTypes.string,
            icon: PropTypes.string,
        })
    ).isRequired,
};

export default SanSourcesReviewCard;
